import React from 'react'

export default class PublicidadeIrregular extends React.Component {
    render() {
        return (
            <React.Fragment>
                <div className="mt-5 font-weight-bold text-left">
                    4 - PUBLICIDADE IRREGULAR (Constado durante visita ao perfil social):
                </div>
                <div className="form-group row mt-3 text-left">
                    <label className="col-8 col-md-2">Divulgação de fotos/vídeos de paciente:</label>
                    <div className="col-4 col-md-4 mb-3">
                        <select className="custom-select"
                            name="fotosVideos"
                            {...this.props}
                            value={this.props.value.fotosVideos} >
                            <option value=""></option>
                            <option value="Sim">Sim</option>
                            <option value="Não">Não</option>
                        </select>
                    </div>
                    {this.renderFotos()}
                    <label className="col-8 col-md-2">Divulgação de honorários:</label>
                    <div className="col-4 col-md-4 mb-3">
                        <select className="custom-select"
                            name="honorarios"
                            {...this.props}
                            value={this.props.value.honorarios} >
                            <option value=""></option>
                            <option value="Sim">Sim</option>
                            <option value="Não">Não</option>
                        </select>
                    </div>
                    <label className="col-8 col-md-4">Divulgação de promoções/pacotes/sessão gratuita:</label>
                    <div className="col-4 col-md-2 mb-3">
                        <select className="custom-select"
                            name="promocoes"
                            {...this.props}
                            value={this.props.value.promocoes} >
                            <option value=""></option>
                            <option value="Sim">Sim</option>
                            <option value="Não">Não</option>
                        </select>
                    </div>
                    <label className="col-8 col-md-4">Divulgação de carta de agradecimento:</label>
                    <div className="col-4 col-md-2 mb-3">
                        <select className="custom-select"
                            name="agradecimento"
                            {...this.props}
                            value={this.props.value.agradecimento} >
                            <option value=""></option>
                            <option value="Sim">Sim</option>
                            <option value="Não">Não</option>
                        </select>
                    </div>
                    <label className="col-8 col-md-2">Outros:</label>
                    <div className="col-4 col-md-4 mb-3">
                        <select className="custom-select"
                            name="outros"
                            {...this.props}
                            value={this.props.value.outros} >
                            <option value=""></option>
                            <option value="Sim">Sim</option>
                            <option value="Não">Não</option>
                        </select>
                    </div>
                    <label className="col-8 col-md-2">Conformidade com a Resolução COFFITO 424/2013 ou 425/2013:</label>
                    <div className="col-4 col-md-4 mb-3">
                        <select className="custom-select"
                            name="conforme424"
                            {...this.props}
                            value={this.props.value.conforme424} >
                            <option value=""></option>
                            <option value="Sim">Sim</option>
                            <option value="Não">Não</option>
                        </select>
                    </div>
                </div>
            </React.Fragment>
        )
    }

    renderFotos() {
        if(this.props.value.fotosVideos == "Sim") {
            return (
                <React.Fragment>
                    <label className="col-8 col-md-2">a. Comparativos “antes e depois”:</label>
                    <div className="col-4 col-md-4 mb-3">
                        <select className="custom-select"
                            name="comparativos"
                            {...this.props}
                            value={this.props.value.comparativos} >
                            <option value=""></option>
                            <option value="Sim">Sim</option>
                            <option value="Não">Não</option>
                        </select>
                    </div>
                    <label className="col-8 col-md-2">b. Exposição durante o tratamento:</label>
                    <div className="col-4 col-md-4 mb-3">
                        <select className="custom-select"
                            name="exposicao"
                            {...this.props}
                            value={this.props.value.exposicao} >
                            <option value=""></option>
                            <option value="Sim">Sim</option>
                            <option value="Não">Não</option>
                        </select>
                    </div>
                </React.Fragment>
            )
        }
    }
}